import React, { useContext, useEffect, useState } from 'react';
import projectContext from '../../context/projects/projectContext';
import taskContext from '../../context/tasks/taskContext';

const FormTasks = () => {

    // Import the state of porjects
    const projectsContext = useContext(projectContext);
    const { project } = projectsContext;

    // Import the state of taskContext
    const tasksContext = useContext(taskContext);
    const { selectedTask, addTask, validateTask, errorTask, getTasks, updateTask, cleanTask } = tasksContext;
    
    // Effect to detects a selected task
    useEffect(() => {
        if(selectedTask !== null){
            setTask(selectedTask);
        } else {
            setTask({
                name: ''
            })
        }
    }, [selectedTask]);
    
    // State of tasks
    const [ task, setTask ] = useState({
        name: ''
    });

    if(!project) return null;

    const [ actualProject ] = project;

    // Read and set the values from the form
    const handleChange = e => {
        setTask({
            ...task,
            [e.target.name]: e.target.value
        })
    }

    // Extract the name of the task
    const { name } = task;

    const onSubmit = e => {
        e.preventDefault();
        
        // Validate the form
        if(name.trim() === ''){
            validateTask();
            return;
        }

        // Validation for selected task for edition or a new task
        if(selectedTask === null){
            // Add new task
            task.project = actualProject._id;
            //task.status = false;
            addTask(task);
        } else {
            // Update existent task
            updateTask(task);
            // Delete selected task
            cleanTask();
        }
        
        
        // Get and filter tasks of the actual project
        getTasks(actualProject.id);

        // Restart the form
        setTask({
            name: ''
        })
    }

    return ( 
        <div className="formulario">
            <form
                onSubmit={ onSubmit }
            >
                <div className="contenedor-input">
                    <input 
                        type="text"
                        className="input-text"
                        placeholder="Task Name..."
                        name="name"
                        value={ name }
                        onChange={ handleChange }
                    />
                </div>
                <div className="contenedor-input">
                    <input 
                        type="submit"
                        className="btn btn-primario btn-submit btn-block"
                        value={ selectedTask ? 'Edit Task' : 'Add Task' }
                    />
                </div>
            </form>
            {
                errorTask 
                    ? <p className="mensaje error">Task name is required</p>
                    : null
            }
        </div>
    );
}
 
export default FormTasks;